import React from "react";
import Title from "../../../../../Universal/Title.component";

const EditHostelCard = ({ handelHostelDetails, _hostelId }) => {
  return (
    <div
      className="flex-col align-start justify-start g-1 p-1 radius-6 back-white"
      style={{ width: "35vw" }}
    >
      <div className="flex-row align-center justify-between">
        <Title className="t-17">
          Hostel {_hostelId && _hostelId.toString()}
        </Title>
        <div className="flex-row align-center justify-start g-1">
          <Title className="t-17 color-black">Rooms: 09</Title>
          <button
            className="actionBtn"
            type="button"
            onClick={() => handelHostelDetails(_hostelId, 1)}
          >
            View Details
          </button>
        </div>
      </div>
      <div className="flex-row align-center justify-between g-1">
        <button
          className="actionBtn w-half"
          type="button"
          onClick={() => handelHostelDetails(_hostelId, 2)}
        >
          Edit details
        </button>
        <button
          className="deleteBtn w-half"
          style={{ background: "var(--redColor)", color: "white" }}
          type="button"
          onClick={() => handelHostelDetails(_hostelId, 3)}
        >
          Delete hostel
        </button>
      </div>
    </div>
  );
};

export default EditHostelCard;
